
import { useMemo } from 'react';

import { Footer, FooterAshevillePlay } from '@components';
import { isCondoWeeklySpeccialMarketingFromPath, isErrorFromPath, isWidgetFromPath, RootState } from '@share/utils';
import { useHistory } from 'react-router-dom';
import {
  isCondoWeeksFromPath,
  isCondoWorldFromPath,
  isThreeDSFromPath,
  isVacationRentalsFromPath,
} from '@share/utils';
import { useSelector } from 'react-redux';

export function ApplicationFooter() {
  const loginStore = useSelector((state: RootState) => state.loginStore);
  const menuStore = useSelector((state: RootState) => state.navigationMenuStore);

  const { account } = loginStore || {};
  const { items } = menuStore || {};

  const history = useHistory();

  const isThreeDS = useMemo(() => isThreeDSFromPath(history), [history]);
  const isErrorPage = useMemo(() => isErrorFromPath(history), [history]);
  const isWidgetPage = useMemo(() => isWidgetFromPath(history), [history]);
  const isCondoWorldMap = useMemo(() => isCondoWorldFromPath(history), [history]);
  const isCondoWeeks = useMemo(() => isCondoWeeksFromPath(history), [history]);
  const isVacationRentals = useMemo(() => isVacationRentalsFromPath(history), [history]);
  const isCondoWeeklySpecialMarketing = useMemo(() => isCondoWeeklySpeccialMarketingFromPath(history), [history]);

  const isAshevillePlay = account?.isAshevillePlay;
  
  // Check if Modern template should be used (both SiteId AND OrgId must match)
  const siteId = items?.siteId;
  const organizationId = items?.organizationId;
  const modernHomeTemplateOrgidList = account?.modernHomeTemplateOrgidList;
  const modernHomeTemplateSiteidList = account?.modernHomeTemplateSiteidList;

  const isInModernOrgId = modernHomeTemplateOrgidList?.includes(organizationId?.toString() as string);
  const isInModernSiteId = modernHomeTemplateSiteidList?.includes(siteId?.toString() as string);

  const useModernTemplate = account?.isRSITemplate && (
    (isInModernOrgId && isInModernSiteId) || 
    (account?.isModernTemplate)
  );

  // Hide footer for Modern template
  if (useModernTemplate) {
    return null;
  }

  if (!isErrorPage && !isWidgetPage && !isCondoWorldMap && !isThreeDS && !isCondoWeeks && !isCondoWeeklySpecialMarketing) {
    if (isAshevillePlay) {
      return <FooterAshevillePlay />;
    }

    return <Footer isVacationRentals={isVacationRentals} />;
  }

  return null;
}
